import ThemeOptions from "./ThemeOptions";
import { combineReducers } from "redux";
import auth from "./auth";
import message from "./message";
import users from "./users";
import faq from "./faq";
import states from "./states";
import cities from "./cities";
import spaces from "./spaces";
import storageTypes from "./storageTypes";
import sources from "./sources";
import backdrops from "./backdrops";
import pages from "./pages";
import reviews from "./reviews";
import reservations from "./reservations";
import report from "./report";
import transactions from "./transactions";
import refunds from "./refunds";
import payouts from "./payouts";
import settings from "./settings";
import becomeAHost from "./becomeAHost";
import storageCategoryReducer from "./storageCategories";
import storageItemsReducer from "./storageItems";
import dynamicMetaDataType from "./dynamicMetaData";
import subSpacesReducer  from "./subSpaces";
import promoCodeReducer from "./promoCodes";
import blockedIpAddressReducer from "./blockedIpAddresses";

const reducers = combineReducers({
  auth,
  message,
  faq,
  users,
  states,
  cities,
  spaces,
  storageTypes,
  backdrops,
  pages,
  sources,
  reviews,
  reservations,
  report,
  transactions,
  refunds,
  payouts,
  settings,
  becomeAHost,
  ThemeOptions,
  storageCategoryReducer,
  storageItemsReducer,
  dynamicMetaDataType,
  subSpacesReducer,
  promoCodeReducer,
  blockedIpAddressReducer
});

export default reducers;
